module.exports = __webpack_public_path__ + "static/media/edit.f46596c2.svg";